import Swiper from 'swiper/dist/js/swiper.min';

const $wrap = $('.webinars-wrapper');

if ($(window).width() <= 1024) {
	$wrap.addClass('swiper-container swiper-slider');
	$wrap.find('.card__item').addClass('swiper-slide');
	$wrap.find('.swiper-slide').wrapAll('<div class="swiper-wrapper"></div>');

	let swiperSlider = new Swiper($wrap, {
		slidesPerView: 'auto',
		spaceBetween: 20,
		scrollbar: {
			hide: false,
			draggable: true,
			el: '.slider-scrollbar',
		},
	});
}